// src/ForgotPassword.js
import React, { useState } from "react";
import Layout from "./Components/Layout";
import { api } from "./lib/api";
import styles from "./styles/Auth.module.css";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setErr("");
    setMsg("");

    try {
      // ✅ api.baseURL already includes /api
      await api.post("auth/forgot-password", {
        email: email.trim().toLowerCase(),
      });

      // ✅ ALWAYS show neutral success (no email enumeration)
      setMsg("If this email exists, a reset link has been sent.");
    } catch {
      // ❌ Only real network/server failure reaches here
      setErr("Unable to process request. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <Layout title="Forgot password">
        <div className={styles.card}>
      <form onSubmit={submit} className={styles.form}>
        <h1>Reset your password</h1>
<h2>Enter your email address that you had registered with us.</h2>

      <p>   <div className={styles.field}>
            <label>Your Email</label><input
          type="email"
          placeholder="Email address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        /></div></p>

       <p> <div className={styles.field}> <button disabled={busy}>
          {busy ? "Sending…" : "Send reset link"}
        </button></div></p>

      <p> <div className={styles.field}>  {msg && <div className={styles.success}>{msg}</div>}
        {err && <div className={styles.error}>{err}</div>}</div></p> 
      </form></div>
    </Layout>
  );
}
